export default __webpack_public_path__ + "static/media/fa-brands-400.9bced931.ttf";